var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M136 39.02h-30.444C104.444 27.898 94.889 19 83.333 19H58.666c-11.555 0-21.11 8.898-22.222 20.02H4a4 4 0 0 0-4 4V124a4 4 0 0 0 4 4h132a4 4 0 0 0 4-4V43.02a4 4 0 0 0-4-4zM88.889 37.4c0 5-5.111 8.967-11.556 8.967H64.89c-6.444 0-11.556-3.966-11.556-8.967v-2.76c0-5 5.112-8.967 11.556-8.967h12.444c6.445 0 11.556 3.967 11.556 8.968V37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M131 112.948c0 3.362-2.662 6.052-5.99 6.052H14.99c-3.328 0-5.99-2.69-5.99-6.052V60.052C9 56.69 11.662 54 14.99 54h109.8c3.327 0 5.988 2.69 5.988 6.052v52.896H131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M26.75 21.564a18.926 18.926 0 0 1-8.09 1.819c-2.962 0-5.765-.69-8.088-1.82C4.566 22.757.161 26.96.161 31.978v6.613h37v-6.613c0-5.081-4.485-9.221-10.411-10.413z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M18.066 20.051c5.612 0 10.115-4.532 10.115-10.025C28.181 4.532 23.61 0 18.066 0S7.95 4.6 7.95 10.094s4.504 9.957 10.116 9.957z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M265.255 151.742C264.59 212.197 215.41 261 154.842 261 93.86 261 44.423 211.527 44.423 150.5c0-5.053.34-10.026.995-14.899H10.933c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H43.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H72.17C92.401 54.401 121.941 40 154.842 40c47.457 0 87.921 29.96 103.537 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z",
    transform: "translate(-1 -40)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(79 61)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "evenodd",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 0.9,
    d: "M136 39.47h-30.852l-.04-.405c-1.1-11.004-10.562-19.615-21.775-19.615H58.666c-11.212 0-20.675 8.611-21.774 19.615l-.04.405H4a3.55 3.55 0 0 0-3.55 3.55V124A3.55 3.55 0 0 0 4 127.55h132a3.55 3.55 0 0 0 3.55-3.55V43.02a3.55 3.55 0 0 0-3.55-3.55zM89.339 37.4c0 5.278-5.334 9.417-12.006 9.417H64.89c-6.672 0-12.006-4.139-12.006-9.417v-2.76c0-5.277 5.334-9.417 12.006-9.417h12.444c6.672 0 12.006 4.14 12.006 9.418V37.4z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(79 61)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "evenodd",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 0.9,
    d: "M130.533 113.398h-.205V60.052c0-3.115-2.461-5.602-5.539-5.602H14.99c-3.078 0-5.539 2.487-5.539 5.602v52.896c0 3.115 2.461 5.602 5.54 5.602h110.02c2.929 0 5.299-2.25 5.523-5.152z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    fillRule: "nonzero",
    d: "M162 96V73.655C162 66.735 157 61 150 61s-12 5.734-12 12.655V96h24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    fillRule: "nonzero",
    d: "M97 123h51v49H97z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EB8181",
    strokeLinecap: "square",
    d: "M158.281 129.5h26.438"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M158.438 141.5h41.125M158.438 152.5h41.125M158.438 162.5h41.125"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104 128)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 0.9,
    d: "M26.805 22.034a19.352 19.352 0 0 1-8.144 1.799c-2.88 0-5.708-.64-8.148-1.798-5.824 1.21-9.902 5.27-9.902 9.942v6.163h36.1v-6.163c0-4.684-4.093-8.721-9.906-9.943z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104 128)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 0.9,
    d: "M18.066 19.601c5.34 0 9.665-4.307 9.665-9.575 0-5.244-4.37-9.576-9.665-9.576C12.785.45 8.4 4.836 8.4 10.094c0 5.254 4.312 9.507 9.666 9.507z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    fillRule: "nonzero",
    d: "M154.105 76.698c-1.407 2.345-4.457 3.05-6.803 1.407-2.345-1.407-3.05-4.457-1.407-6.803 1.407-2.345 4.457-3.05 6.803-1.407 2.345 1.407 3.05 4.456 1.407 6.803z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignation);
export default __webpack_public_path__ + "static/media/designation.ec53d76b482769346eb55aef86c0bdb3.svg";
export { ForwardRef as ReactComponent };